import { render, staticRenderFns } from "./TaskSettings.vue?vue&type=template&id=5d4bd02a&scoped=true"
import script from "./TaskSettings.vue?vue&type=script&lang=js"
export * from "./TaskSettings.vue?vue&type=script&lang=js"
import style0 from "./TaskSettings.vue?vue&type=style&index=0&id=5d4bd02a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4bd02a",
  null
  
)

export default component.exports